module.exports = __webpack_public_path__ + "static/media/successStoryQuotePlaceholder.de7cff9d.svg";